<app-info-section [header]="'Personal Information'" [details]="userDetails"></app-info-section>

<app-view-transfer-history *ngIf="sentDataReady" [header]="'Sent Transfers'" [transferHistory]="sentTransferHistory"></app-view-transfer-history>

<app-view-transfer-history *ngIf="receivedDataReady" [header]="'Received Transfers'" [transferHistory]="receivedTransferHistory"></app-view-transfer-history>
